import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { StationInfo } from "../model/StationInfo";
import { Observable } from 'rxjs';
import {map} from "rxjs/operators";
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdditionalStationInfoService {

  private baseUrl = '/station-info/';

  constructor(private http: HttpClient) {}

  getAll(pageNo: number, pageSize: number, searchString: string): Observable<StationInfo[]> {
    return this.http.get<StationInfo[]>(environment.API_URL + this.baseUrl, {
      params: {
        pageNo: pageNo.toString(),
        pageSize: pageSize.toString(),
        searchString
      }
    }).pipe(
      map(stations => stations.map(station => ({
        ...station,
      })))
    );
  }

  getActive(): Observable<StationInfo[]> {
    return this.http.get<StationInfo[]>(`${environment.API_URL}${this.baseUrl}active`);
  }

  count(searchString: string = ''): Observable<number> {
    return this.http.get<number>(environment.API_URL + this.baseUrl + `count`, {
      params: {searchString}
    });
  }

  getById(id: number): Observable<StationInfo> {
    return this.http.get<StationInfo>(environment.API_URL + this.baseUrl + `find`, {
      params: {stationInfoId: id.toString()}
    });
  }

  create(info: StationInfo, file: File): Observable<boolean> {
    const formData = new FormData();
    formData.append('icon', file);
    formData.append('infoLabel', info.infoLabel);
    formData.append('isActive', info.active ? 'true' : 'false');

    Object.keys(info).forEach(key => {
      if (['infoLabel', 'icon', 'isActive'].includes(key)) return;
      const value = (info as any)[key];
      if (value !== null && value !== undefined) {
        formData.append(key, value.toString());
      }
    });

    return this.http.post<boolean>(environment.API_URL + this.baseUrl + `new`, formData);
  }


  edit(info: StationInfo, file?: File, originalIconName?: string): Observable<boolean> {
    const formData = new FormData();
    formData.append('stationInfo', new Blob([JSON.stringify(info)], { type: 'application/json' }));
    if (file) formData.append('file', file);
    if (originalIconName) formData.append('originalIconName', originalIconName);
    return this.http.post<boolean>(environment.API_URL + this.baseUrl + `edit`, formData);
  }


  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(environment.API_URL + this.baseUrl, {
      params: {stationInfoId: id.toString()}
    });
  }

}


